<template>
  <div class="vhp-breadcrumb container-width">
    <span 
      class="vhp-breadcrumb-item"
      :class="item.disabled ? 'disabled' : ''"
      v-for="(item, idx) in items"
      :key="'vbi-' + item.path"
    >
      <span :class="item.target ? 'target' : ''" @click="goRoute(item.path)">{{$t(item.title)}}</span>
      
      <span class="right" v-if="idx !== items.length - 1">
        <img src="@/assets/image/arrow-right.svg/" alt="arrow" height="12"/>
      </span>
    </span>
  </div>
</template>

<script>
export default {
    props:{
      models:Array
    },
    computed:{
      items() {
        let items = []

        if(this.models) {
          return this.models
        }

        const path = this.$route.path || ''
        if (path.indexOf('/news/blog-details') !== -1) {
          items = [
            { title: '홈', path: '/' },
            { title: '소식', path: '/news' },
            { title: '블로그', path: '/news/blog' },
            { title: '상세 블로그', path: '', target: true, disabled: true }
          ]
          return items
        }

        if(this.$route.matched.length > 0) {
          items.push({
            title:'홈',
            path:'/'
          })
        }

        for(let i = 0; i < this.$route.matched.length; i++) {
          if(this.$route.matched[i].name) {
            const segment = this.$route.matched[i]
            const fullPath = segment.path.indexOf('/') === 0 ? segment.path : (items.length > 0 ? (items[items.length - 1].path + '/' + segment.path).replace(/\/+/g, '/') : '/' + segment.path)
            items.push({
              title: segment.name,
              path: fullPath,
              target: i === this.$route.matched.length - 1
            })
          }
        }

        return items
      }
    },
    data() {
        return {
        }
    },
    methods:{
      goRoute(path){
        if (!path) return
        this.$router.push(path)
      }
    }

}
</script>

<style lang="scss" src="./vhpBreadcrumb.scss"></style>